import { UPDATE_DESIGN_NAME } from '../mutation_types.js'
import { DESIGN_TABS } from '../design_tabs.js'

export default {
  namespaced: true,
  state: {
    name: 'Test Design',
    details: {},
    gotDetails: false,
    tabs: []
  },
  getters: {
    getActiveDesignName: state => {
      return state.name
    },
    getActiveDesignDetails: state => {
      DESIGN_TABS.forEach((item) => {
        if (item.name === state.name) {
          state.details = item
          state.gotDetails = true
        } else {
          if (!state.gotDetails) {
            state.details = {}
          }
        }
      })
      return state.details
    },
    getDesignTabs: state => {
      state.tabs = DESIGN_TABS
      return state.tabs
    }
  },
  mutations: {
    [UPDATE_DESIGN_NAME] (state, designName) {
      state.name = designName
    }
  },
  actions: {
    updateActiveDesignName ({commit}, designName) {
      commit(UPDATE_DESIGN_NAME, designName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/design_store.js